module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only",
    attrs: {
      "xs12": "",
      "sm3": "",
      "text-xs-right": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 100,
      "imaSrc": "design/gray-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Administración del dinero",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v("Administración"), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("del ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" dinero")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Administración del dinero',
      "videoEmbed": "ADMINISTRACIONDINERO02AdministracionDelDinero.mp4"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "animated fadeInDown dura_2 adorn-bottom",
    attrs: {
      "xs12": "",
      "sm8": "",
      "mb-5": ""
    }
  }, [_c('p', [_vm._v("Las personas reconocen la importancia de administrar el dinero, sin embargo la mayoría cree hacerlo bien \n        solo porque pagan sus cuentas a tiempo. Pero para administrar el dinero correctamente es necesario observar \n        cómo el panorama completo de los ingresos, gastos, patrimonio y deudas afecta las finanzas personales.\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ccc79d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-02.vue
// module id = 972
// module chunks = 1